import { render, staticRenderFns } from "./ShareStirpesAge.vue?vue&type=template&id=0070f103"
import script from "./ShareStirpesAge.vue?vue&type=script&lang=js"
export * from "./ShareStirpesAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports